export const API_CREATE_ORDER = 'fe-api-createOrder';
export const API_SUBSCRIPTION_EXISTING_USER =
  'fe-api-dev-subscriptionVoucher-existing-user';
export const API_AUTH = 'fe-api-auth';
